import React from 'react';
import {Button} from "react-bootstrap";

const Row = ({ affid, subid, country, factor, updateFactor}) => {

    return (
        <tr>
            <td>{affid}</td>
            <td>{subid}</td>
            <td>{country}</td>
            <td>{factor}</td>
            <td style={{ width: '1%', whiteSpace: 'nowrap' }}>
                <Button bsStyle={'primary'} onClick={() => updateFactor(affid, subid, country)}>
                    Edit Factor
                </Button>
            </td>
        </tr>
    );
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/DynamicHourlyCutoffAll/components/Table/components/Row/index.js